import Service from '@/service/index.js';
export default {
  components: {
  },
  props: ['transfereeInfo', 'projectInfo'],
  data() {
    return {
      assignmentConditionArr: [],
      qualificationRestrictionList: []
    };
  },
  created() {
    const arr = [
      ['qualificationRestrictionList', 'QUALIFICATION_RESTRICTION']
    ];
    arr.forEach((value) => {
      if (!value.length) {
        return;
      }
      Service.getSelectList(value[1]).then(res => {
        if (res && res.code === '0') {
          this[value[0]] = res.data;
        }
      });
    });
  },
  computed: {
    projectCode() {
      if(this.projectInfo && this.projectInfo.projectType && this.projectInfo.projectSubType) {
        return `${this.projectInfo.projectType}-${this.projectInfo.projectSubType}`;
      }
    }
  },
  watch: {
    transfereeInfo (newObj) {
      if (newObj) {
        // console.log(newObj && newObj.assignmentCondition && String(newObj.assignmentCondition));
        this.assignmentConditionArr = newObj && newObj.assignmentCondition && newObj.assignmentCondition.toString().split('\n');
        // console.log(this.assignmentConditionArr);
      }
    }
  },
  methods: {
  }
};
